// extracted by mini-css-extract-plugin
module.exports = {"Container":"DashBoardStyle_Container__34Q3g","items":"DashBoardStyle_items__1-ShM"};